import React from 'react'
import cn from 'classnames'
import {
  Button,
  type ButtonSizeValue,
  IconGiftDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { getPageSource } from '@mc/track-event'
import { PROMO_I18N_NAMESPACE } from '../../lib/constants'
import { trackCtaClicked } from '../../lib/events'
import styles from './GiftButton.module.scss'

interface GiftButtonProps {
  className?: string
  size?: ButtonSizeValue
  fullWidth?: boolean
  location: string
}

export const GiftButton = ({
  className = '',
  size = 'md',
  fullWidth = false,
  location,
}: GiftButtonProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <Button
      fullWidth={fullWidth}
      className={cn(
        'd-flex justify-content-center flex-gap-1',
        className,
        styles.alignItemsCenter,
      )}
      kind='tertiary'
      onClick={() =>
        trackCtaClicked({
          action: 'Gift',
          location,
          href: paths.gift,
          pageSource: getPageSource(),
        })
      }
      as='a'
      href={paths.gift}
      size={size}
    >
      <IconGiftDefault size='sm' />
      {t('common.cta.secondary')}
    </Button>
  )
}
